import { OnlineFunnel } from "~/constants/Funnel";
import type { Maybe, MembershipPerks, Money } from "~/generated/graphql";
import { MembershipPerksType } from "~/generated/graphql";

const DEFAULT_PERKS: Money = { amount: 0, currency: "EUR" };

export const getPerksForFunnel = (
  membershipPerks: Maybe<MembershipPerks> | undefined,
  funnel: OnlineFunnel,
): Money => {
  if (!membershipPerks) {
    return DEFAULT_PERKS;
  }
  const perkTypeFilter =
    funnel === OnlineFunnel.FLIGHTS
      ? MembershipPerksType.ItineraryPerks
      : MembershipPerksType.AccommodationPerks;
  const perk = membershipPerks.perks.find(
    (perk) => perk.perkType === perkTypeFilter,
  );
  return perk?.discount || DEFAULT_PERKS;
};

export const isValidPerks = (perks: Money): boolean => {
  return perks.amount !== 0;
};
